import { useCallback, useEffect, useReducer, useState } from "react";
import { AppStateProvider } from "../state/Provider";
import { reducer } from "../state";
import { IADPActions } from "../state/Actions";

const _provider = AppStateProvider.getInstance();

export function useLoggingReducer() {
  const [logEvents, setLogEvents] = useState(true);
  const [state, _dispatch] = useReducer(reducer, _provider.getState());

  // keyboard shortcut to toggle logging events or log state
  const handleKeyPress = useCallback((event: KeyboardEvent) => {
    // Toggle logging events with ctrl + shift + l
    if (event.key === "L" && event.shiftKey && event.ctrlKey) {
      setLogEvents((prev) => !prev);
    }
    // Print a table of state by using ctrl + shift + s
    if (event.key === "S" && event.shiftKey && event.ctrlKey) {
      console.table(state);
    }
  }, []);

  useEffect(() => {
    document.addEventListener("keydown", handleKeyPress);

    return () => document.removeEventListener("keydown", handleKeyPress);
  }, []);

  useEffect(() => {
    _provider.setState(state);
  }, [state]);

  const dispatch = useCallback(
    (action: IADPActions) => {
      if (logEvents) {
        console.table(action);
        _dispatch(action);
      }
    },
    [logEvents, _dispatch]
  );

  return [state, dispatch] as const;
}
